import React, { useEffect, useState } from "react";
import "./status.css";
import * as io from "socket.io-client";
import config from "../../env.json";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
function Status() {
  useEffect(() => {
    const socket = io.connect(
      config.REACT_APP_ENV_API_BASE.replace("/api", "")
    );
    socket.emit("join", "statusSocket");

    socket.on("message", (id: any, data: any) => {

      
      //considering data is this format
      // {
      //   key:Resouce
      //   child:{	
      //     key: creation
      //     message: Resource Creation failed
      //     done:false
      //     loading:false
      //     }	
      //   },
      if(data){
        let starray: any = [];
        if (window.localStorage.getItem("statusarray"))
          starray = JSON.parse(window.localStorage.getItem("statusarray") as any);
        //adding date time to data
        var d = new Date,
    dformat = [d.getMonth()+1,
               d.getDate(),
               d.getFullYear()].join('/')+' '+
              [d.getHours(),
               d.getMinutes(),
               d.getSeconds()].join(':'); 
        data.child.date=dformat
        let index = starray.findIndex((x:any)=>x.key==data.key)
        debugger
        if(index<0){
          starray.push(
            {
              key:data.key,
              child:[data.child]
            }
          )
        }else{
debugger
          let subindex=starray[index].child.findIndex((x:any)=>x.key==data.child.key)
          if(subindex<0)
          starray[index].child.push(data.child)
          else
          starray[index].child[subindex]=data.child
        }
        //considering this object to be rendered on frontend
        // {
        //   key:Resouce
        //   child:	[
        //     {
        //     key: creation
        //     message: Resource Creation started 
        //     done:false
        //     loading:true
        //     },	
        //     {	
        //     key: creation
        //     message: Resource Creation completed
        //     done:true
        //     loading:false
        //     },
        //     {	
        //     key: creation
        //     message: Resource Creation failed
        //     done:false
        //     loading:false
        //     },
        //     ]
        //   },
      
        window.localStorage.setItem("statusarray", JSON.stringify(starray));
        setStatusArray(starray);
      }
      
    });
  }, []);
  const [statusArray, setStatusArray] = useState<any>([]);
  return (
    <div className="statusSocket">
      {(statusArray.length==0) && (<div style={{textAlign:'center'}}>
        <h3>Fetching details, It might take 4 to 5 minutes...<CircularProgress size={"1rem"} /></h3>
        </div>)}
      {statusArray.map((item: any, index: number) => (
        <div className="order-track-step">
          <div className="order-track-status">
            <span
              className={`order-track-status-dot`}
            ></span>
            <span className="order-track-status-line"></span>
          </div>
          <div className="order-track-text">
            <p className="order-track-text-stat">{item.key}</p>
            {
              item.child?.map((subItem:any)=>(
                <div className="order-track-text-sub">
                 <span> {subItem.message}</span>
                 
                  {
                    subItem.loading && <span> <span> ......</span> <span><CircularProgress size={"1rem"} /></span></span>
                  }
                  {
                    subItem.done && <span> <span> ......</span> <span> < CheckCircleRoundedIcon color="success" style={{fontSize:"1rem"}}/></span></span>
                  }
                  {
                    (!subItem.done && !subItem.loading) && <span> <span> ......</span> <span><ErrorRoundedIcon color="error" style={{fontSize:"1rem"}}/></span></span>
                  }
                <div> {subItem.date}</div>
                </div>
              ))
            }
            
          </div>
        </div>
      ))}
    </div>
  );
}

export default Status;
